import { LoadingState } from "@app/root-store/api-result.state";
import { CustomerLocationActions } from "../actions";
import { CustomerLocationState, initialState } from "../customer-location.state";

const CustomerLocationActionTypes = CustomerLocationActions.ActionTypes;

export const reducer = (state = initialState, action: CustomerLocationActions.Actions = null): CustomerLocationState => {
    switch (action?.type) {
        case CustomerLocationActionTypes.GetLocationsByCustomer: {
            return {
                ...state,
                claresystems: {
                    ...state.claresystems,
                    customerId: action.payload.customerId,
                    callState: LoadingState.loading,
                },
            };
        }

        case CustomerLocationActionTypes.GetLocationsByCustomerFailure: {
            return {
                ...state,
                claresystems: {
                    ...state.claresystems,
                    callState: action.error,
                },
            };
        }

        case CustomerLocationActionTypes.GetLocationsByCustomerSuccess: {
            return {
                ...state,
                claresystems: {
                    result: action.result.claresystems,
                    customerId: action.result.customerId,
                    callState: LoadingState.loaded,
                },
            };
        }

        case CustomerLocationActionTypes.UpdateLocationSuccess: {
            const id = state.claresystems.result.findIndex(claresystem => claresystem.claresystem.id === action.result.claresystem.id);
            const claresystemResult = state.claresystems.result;
            claresystemResult[id] = action.result;
            return {
                ...state,
                claresystems: {
                    ...state.claresystems,
                    result: claresystemResult,
                },
            };
        }

        case CustomerLocationActionTypes.ClearLocationUsersState: {
            const result = [];
            const uuid = action.payload.claresystem.uuid;
            return {
                ...state,
                users: {
                    ...state.users,
                    [uuid]: { result, uuid, callState: LoadingState.init },
                },
            };
        }

        case CustomerLocationActionTypes.GetLocationUsers: {
            const uuid = action.payload.claresystem.uuid;
            return {
                ...state,
                users: {
                    ...state.users,
                    [uuid]: { ...state.users[uuid], uuid, callState: LoadingState.loading },
                },
            };
        }

        // TODO: Fix the payload/error so we can update the specific uuid
        case CustomerLocationActionTypes.GetLocationUsersFailure: {
            return state;
        }

        case CustomerLocationActionTypes.GetLocationUsersSuccess: {
            const uuid = action.result.claresystem.uuid;
            const result = [...action.result.users].sort((a, b) => (a.userinfo.email || "").localeCompare(b.userinfo.email || ""));

            return {
                ...state,
                users: {
                    ...state.users,
                    [uuid]: { result, uuid, callState: LoadingState.loaded },
                },
            };
        }

        case CustomerLocationActionTypes.InviteUserToLocation: {
            const uuid = action.payload.claresystem.uuid;
            return {
                ...state,
                users: {
                    ...state.users,
                    [uuid]: {
                        ...state.users[uuid],
                        callState: LoadingState.loading,
                    },
                },
            };
        }

        case CustomerLocationActionTypes.InviteUserToLocationSuccess: {
            const uuid = action.result.claresystem.uuid;
            const users = state.users[uuid].result;
            users.push({ userinfo: action.result.invitedUser });

            return {
                ...state,
                users: {
                    ...state.users,
                    [uuid]: {
                        ...state.users[uuid],
                        result: users,
                        callState: LoadingState.loaded,
                    },
                },
            };
        }

        case CustomerLocationActionTypes.InviteUserToLocationFailure: {
            const uuid = action.error.requestData?.claresystem?.uuid;
            return {
                ...state,
                users: {
                    ...state.users,
                    [uuid]: {
                        ...state.users[uuid],
                        callState: LoadingState.loaded,
                    },
                },
            };
        }

        case CustomerLocationActionTypes.GetCustomerRoleIdSuccess: {
            return {
                ...state,
                customerRoleId: action.result.customerRoleId,
            };
        }

        case CustomerLocationActionTypes.DeleteLocationUserSuccess:
        case CustomerLocationActionTypes.RemoveLocationSuccess: {
            let people = [];
            if (state.users[action.result.claresystem.uuid]) {
                people = state.users[action.result.claresystem.uuid].result.filter(user => user.userinfo.id !== action.result.userInfoId);
            }
            return {
                ...state,
                users: {
                    ...state.users,
                    [action.result.claresystem.uuid]: {
                        result: people,
                        callState: LoadingState.loaded,
                    },
                },
            };
        }

        case CustomerLocationActionTypes.GetLocationData: {
            const uuid = action.payload.uuid;
            const data = state.locationData[uuid];
            return {
                ...state,
                locationData: {
                    ...state.locationData,
                    [uuid]: {
                        result: data?.result ?? null,
                        uuid,
                        callState: LoadingState.loading,
                    },
                },
            };
        }

        case CustomerLocationActionTypes.GetLocationDataSuccess: {
            const uuid = action.result.uuid;
            return {
                ...state,
                locationData: {
                    ...state.locationData,
                    [uuid]: {
                        result: action.result.result,
                        uuid,
                        callState: LoadingState.loaded,
                    },
                },
            };
        }

        case CustomerLocationActionTypes.GetLocationDataFailure: {
            const uuid = action.error.requestData?.uuid;
            return {
                ...state,
                locationData: {
                    ...state.locationData,
                    [uuid]: {
                        result: null,
                        uuid,
                        callState: LoadingState.loaded,
                    },
                },
            };
        }

        default:
            return state;
    }
};
